<template>
  <div>
    <div v-if="componentLoading" class="please-wait">
      <PleaseWait></PleaseWait>
    </div>

    <CommunityCard v-else class="p-4 col-12 d-flex">
      <div class="left-content">
        <h5 class="m-0 text-inherit">{{ user.first_name }} {{ user.last_name }}</h5>

        <img
          class="mb-3"
          src="../assets/user-profile-picture-placeholder.png"
          style="width:50%; height:auto"
          alt="profile picture"
        />
        <div class="scenario-stats my-2 d-flex flex-column">
          <div class="d-flex align-items-center">
            <i class="material-icons text-secondary">insert_chart</i>
            <em>Scenarios Contributed:</em>
            <em>{{ this.usersScenarios.length }}</em>
          </div>

          <div class="d-flex align-items-center">
            <i class="material-icons text-secondary">star</i>
            <em>Favourited:</em>
            <span class="element-label">
                <em>{{ this.numberOfTimesFavourited }}</em>
              </span>
          </div>
          <div class="d-flex align-items-center">
            <i class="material-icons text-secondary">stars</i>
            <em>Been Favourited:</em>
            <em>{{ this.numberOfTimesFavourited }}</em>
          </div>
        </div>
      </div>
      
      <div class="right-content">
        <div class="w-50">
          <div class="d-flex justify-content-start align-items-center">
            <i
              class="favourite-icon material-icons mt-1 mr-2"
            >insert_chart_outlined</i>
            <h5 class="mt-4 mb-3">Contributed Scenarios</h5>
          </div>
          <div v-if="usersScenarios.length > 0">
            <ol class="mini-scenarios list-group mb-3 ml-0">
              <li
                class="row scenario bg-light mx-2 p-3 d-flex"
                v-for="scenario in usersScenarios"
                :key="scenario.uuid_id"
              >
                <MiniScenario
                  :uuidId="scenario.uuid_id"
                  :deviceId="scenario.device_id"
                  :name="scenario.name"
                ></MiniScenario>
              </li>
            </ol>
          </div>
          <div v-else class="alert alert-secondary" role="alert">
            {{ user.first_name }} has not contributed any public scenarios yet.
            <br />
            <router-link to="/scenarios">See scenarios scontributed by others.</router-link>
          </div>
        </div>

        <div class="w-50">
          <div class="d-flex justify-content-start align-items-center">
            <i class="favourite-icon material-icons mt-1 mr-2">star</i>
            <h5 class="mt-4 mb-3">Favourites</h5>
          </div>
          <div v-if="usersScenarios.length > 0">
            <ol class="mini-scenarios list-group mb-3 ml-0">
              <li
                class="row scenario bg-light mx-2 p-3 d-flex"
                v-for="scenario in favouriteScenarios"
                :key="scenario.uuid_id"
              >
                <MiniScenario
                  :uuidId="scenario.uuid_id"
                  :deviceId="scenario.device_id"
                  :name="scenario.name"
                ></MiniScenario>
              </li>
            </ol>
          </div>
          <div
            v-else
            class="alert alert-secondary"
            role="alert"
          >{{ user.first_name }} has not favourited any scenarios yet.
          </div>
        </div>
      </div>
    </CommunityCard>
  </div>
</template>

<script>
import UserService from "../services/user.service";
import ScenService from "../services/scenarios.service";
import MiniScenario from "../components/MiniScenario";
import PleaseWait from "../components/PleaseWait";
import CommunityCard from "@/components/CommunityCard";

export default {
  name: "User",
  components: {
    CommunityCard,
    MiniScenario,
    PleaseWait
  },
  beforeMount() {
    this.getUser();
  },
  data: function () {
    return {
      componentLoading: true,
      numberOfTimesFavourited: 0,
      user: {},
      favouriteScenarios: [],
      usersScenarios: [],
    };
  },
  methods: {
    getUser() {
      this.componentLoading = true;
      UserService.getUserDetails(this.$route.params.id)
        .then(async (data) => {
          this.user = data;
          await Promise.all([
            this.getUsersPublicScenarios(),
            this.getUsersFavouritedScenarios(),
          ]);
        })
        .finally(() => {
          this.componentLoading = false;
        });
    },
    getUsersPublicScenarios() {
      return ScenService.getUsersPublicScenarios(this.user.uuid_id).then(data => {
        this.usersScenarios = data.scenarios;
        this.usersScenarios.forEach(scenario => {
          this.numberOfTimesFavourited += scenario.number_favourites;
        });
      });
    },
    getUsersFavouritedScenarios() {
      return ScenService.getUsersFavouritedScenarios(this.user.uuid_id).then(data => {
        data.forEach(element => {
          this.favouriteScenarios.push(element.scenario);
        });
      });
    },
  },
};
</script>

<style scoped>
.left-content {
  width: 30%;
}

.right-content {
  width: 70%;
  display: flex;
}

.scenario {
  min-height: 100%;
}

.please-wait {
  height: 60vh;
}

.favourite-icon {
  font-size: 20px;
  color: var(--isim-light-text);
}
</style>
